import React, { useState, useEffect } from "react";
import BlogCard from "../Card/BlogCard";
import { useAppContext } from "../../contexts/AppContext";
import axios from "axios";
import parse from "html-react-parser";
import Loading from "../Loading/Loading";

function Blogs() {
  const { backendUrl, translate } = useAppContext();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCount, setShowCount] = useState(3);
  const route = "/news";

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${backendUrl}${route}`);

        if (Array.isArray(response?.data)) {
          // Sort by 'order' primarily, then by createdAt descending
          const sortedData = response.data.sort((a, b) => {
            if (a.order !== b.order) {
              return a.order - b.order;
            }
            const dateA = new Date(a.createdAt || a.date || 0);
            const dateB = new Date(b.createdAt || b.date || 0);
            return dateB - dateA;
          });
          setData(sortedData);
        }
      } catch (error) {
        console.error("Error fetching blog data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogData();
  }, [backendUrl]);

  const blogsToDisplay = data.slice(0, showCount);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="blog-section-container py-5 bg-white">
      <div className="container">
        <div className="d-flex w-100 align-items-center justify-content-center mt-3">
          <div className="service-title-container mb-5">
            <h1>{parse(translate("Latest Posts").toUpperCase())}</h1>
            <div className="title-underlined"></div>
          </div>
        </div>

        {data.length > 0 ? (
          <div className="blog-feed">
            {blogsToDisplay.map((blog) => (
              <BlogCard key={blog.id || blog._id} data={blog} />
            ))}
          </div>
        ) : (
          <div className="text-center text-muted py-5">
            {parse(translate("No posts available yet."))}
          </div>
        )}

        {showCount < data.length && (
          <div className="d-flex justify-content-center mt-4">
            <button
              className="btn btn-primary rounded-pill px-5 py-2 fw-bold shadow-sm"
              onClick={() => setShowCount(prev => prev + 3)}
              style={{ transition: "all 0.3s ease" }}
            >
              {parse(translate("Show More"))}
              <i className="bi bi-chevron-down ms-2"></i>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Blogs;
